<template>
    <base-spinner :open="isloading"></base-spinner>
    <!-- The Modal -->
    <div id="myModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content-smartpage">
        <span class="close-button">&times;</span>
            <iframe id="popupiframe" style="width: 100%;height: 95%; border: 0;"></iframe>
        </div>
    </div>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb-bottom-adjust" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <a href="/index" class="breadcrumb__item-link">Home</a>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <a href="" class="breadcrumb__item-link">Breadcrumb</a>
                                    </li>		
                                    <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                        <span class="breadcrumb__item-link">Search Results</span>
                                    </li>								                               
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div> 
                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Search Results</h1>
                        </div>
                            
                        <div class="flex-item-page-info-selected-vehcile">
                            <div class="flex-container--breadcrumbs-selected-vehicle">
                                <div class="flex-container--select-vehicle-column">
                                    <div class="vehicles-list__item-name">2018 Chevrolet Silverado 1500 LT</div>
                                    <div class="vehicles-list__item-details-category-display">V8-325 CID 5.3L FLEX FI VIN C-L83</div>
                                </div>					
                                <div class="flex-container--select-vehicle-column">
                                    <div class="product__tags tags tags--sm">
                                        <div class="tags__list tags__list-select-vehicle">                         
                                            <button class="mobile-search__vehicle-picker change-vehicle__button" type="button">
                                                <span class="search__button-icon">
                                                    <svg width="20" height="20">
                                                        <path d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1
                    c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2
                    C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9
                    c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0
                    c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0
                    C15.5,10.2,14,11.3,14,12z" />
                                                    </svg>
                                                </span>
                                            <span class="search__button-title">Change Vehicle</span>
                                            </button>                                                      
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>			                                                
                </div>
            </div>
        </div>
        <div class="block-split">
            <div class="container">
                <div class="block-split__row row no-gutters">
                    <!-- <search-results-filter></search-results-filter> -->
                    <div class="block-split__item block-split__item-content col-auto">
                        <div class="block">
                            <div class="products-view">
                                <base-message
                                v-if="servermessages.length > 0"
                                :servermessages="servermessages"
                                ></base-message>
                                <page-display-options-search></page-display-options-search>
                                <search-results-list :parts="parts"></search-results-list>
                                <!-- <pagination></pagination> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-space block-space--layout--before-footer"></div>
            </div>
        </div>
    </div>
</template>



<script>
import PageDisplayOptionsSearch from './PageDisplayOptionsSearch';
// import SearchResultsFilter from './SearchResultsFilter';
// import Pagination from '../productbrowse/Pagination';
import SearchResultsList from './SearchResultsList';
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    name: 'SearchResults',
    components: {
        // SearchResultsFilter,
        SearchResultsList,
        PageDisplayOptionsSearch,
        // Pagination
    }, 
    data() {
        return {
            parts: [],
            isloading: false,
            servermessages: []
        };
    },
    computed: {
        ...mapGetters("product", [
            "interchange_manufacturers",
        ]),
        ...mapGetters("message", [
            "sharedmessages",
            "sharedmessagestatus"
        ])
    },
    methods: {
        getSubstitutes() {
            this.parts = [];
            for (const key in this.interchange_manufacturers) {
                 this.isloading = true;
                // For each manufacturer, call the server module
                this.getParts(this.interchange_manufacturers[key].manufacturer, this.interchange_manufacturers[key].description);
            }
        },
        getParts(manufacturer, desc) {
            const catpn = this.$store.getters['storeConfigID'];
            axiosvl.post(this.$store.getters['api/interchange_substitutes_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "CATPN": {"value": catpn},
                        "NEWITEM": {"value": this.$store.getters['product/interchange_sku']},
                        "QCMFRC": {"value": manufacturer }
                    }
                }
            }).then((response) => {
                const fields = response.data.webroutine.fields
                let results = [];

                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.PARTS.entries) {
                        const obj = response.data.webroutine.lists.PARTS.entries[key];
                        results.push({
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            description: obj.QITDSC,
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            stockquantity: obj.QOHAND,
                            availability: obj.QOSTK,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: obj.EPIMG,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                        });
                    }

                    this.parts.push({
                        "manufacturer": manufacturer,
                        "description": desc,
                        "isloading": false,
                        "parts": results
                    });  

                    this.isloading = false;
                } 
            }).catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        }
    },
    watch: {
        sharedmessagestatus(newVal) {
            if (newVal === 'complete') {
                // This indicates that messages were stored on the state
                let msgs = this.$store.getters['message/sharedmessages']

                if (msgs["InterchangeSearch"] != undefined) {
                    this.servermessages = msgs["InterchangeSearch"];
                }

            }
            this.$store.dispatch("message/resetStatus");
        },
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        this.getSubstitutes();
    }
}
</script>
